import React from 'react';
import { Link } from 'react-router-dom';
import { BsCalendar, BsClock } from 'react-icons/bs';
import { getArticlesByTag } from '../../data/articles';

function RelatedArticles({ currentArticle }) {
  if (!currentArticle) return null;

  // Find articles with matching tags
  const relatedArticles = currentArticle.tags
    .flatMap(tag => getArticlesByTag(tag))
    .filter(article => article.id !== currentArticle.id) // Exclude current article
    .reduce((unique, article) => {
      // Remove duplicates
      if (!unique.find(a => a.id === article.id)) {
        unique.push(article);
      }
      return unique;
    }, [])
    .slice(0, 3); // Show max 3 related articles

  if (relatedArticles.length === 0) return null;

  return (
    <div className="related-articles">
      <h2 className="related-articles-heading">Related Articles</h2>
      <div className="related-articles-grid">
        {relatedArticles.map((article) => (
          <Link
            key={article.id}
            to={`/articles/${article.id}`}
            className="related-article-card"
          >
            <img
              src={article.coverImage}
              alt={article.title}
              className="related-article-image"
            />
            <div className="related-article-content">
              <h3 className="related-article-title">{article.title}</h3>
              <p className="related-article-description">
                {article.description}
              </p>
              <div className="related-article-meta">
                <span className="related-article-date">
                  <BsCalendar size={14} />
                  {new Date(article.date).toLocaleDateString('en-US', {
                    month: 'short',
                    day: 'numeric',
                    year: 'numeric'
                  })}
                </span>
                <span className="related-article-read-time">
                  <BsClock size={14} />
                  {article.readTime}
                </span>
              </div>
              <div className="related-article-tags">
                {article.tags.slice(0, 3).map((tag, index) => (
                  <span key={index} className="related-article-tag">
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}

export default RelatedArticles;